<h1 mat-dialog-title>{{"registration.register" | translate}}</h1>

<div style="padding-left: 5%;">
    <form [formGroup]="form">
        <mat-form-field appearance="standard" color="standart" style="margin-bottom: -10px; width: 225px;">
            <mat-label>{{"registration.customerNumber" | translate }}<span class="span-label-required"></span></mat-label>
            <input matInput formControlName="customerNumber">
        </mat-form-field>
        <span style="color: red;" *ngIf="(form.get('customerNumber').errors?.required && (form.get('customerNumber').touched || (form.get('customerNumber').dirty)))">
            {{"common.validation.registration.customerNumberRequired" | translate}}
        </span>

        <mat-form-field appearance="standard" color="standart" style="margin-bottom: -10px; width: 225px;">
            <mat-label>{{"registration.customerName" | translate }}<span class="span-label-required"></span></mat-label>
            <input matInput formControlName="customerName">
        </mat-form-field>
        <span style="color: red;" *ngIf="(form.get('customerName').errors?.required && (form.get('customerName').touched || (form.get('customerName').dirty)))">
            {{"common.validation.registration.customerNameRequired" | translate}}
        </span>

        <mat-form-field appearance="standard" color="standart" style="margin-bottom: -10px; width: 225px;">
            <mat-label>{{"registration.email" | translate }}<span class="span-label-required"></span></mat-label>
            <input matInput formControlName="email">
        </mat-form-field>
        <span style="color: red;" *ngIf="(form.get('email').errors?.required && (form.get('email').touched || (form.get('email').dirty)))">
            {{"common.validation.registration.emailRequired" | translate}}
        </span>
        <span style="color: red;" *ngIf="(form.get('email').errors?.email && (form.get('email').touched || (form.get('email').dirty)))">
            {{"common.validation.email" | translate}}
        </span>

        <mat-form-field appearance="standard" color="standart" style="margin-bottom: -10px; width: 225px;">
            <mat-label>{{"registration.city" | translate }}</mat-label>
            <input matInput formControlName="city">
        </mat-form-field>

        <mat-form-field appearance="standard" color="standart" style="margin-bottom: -10px; width: 225px;">
            <mat-label>{{"registration.zip" | translate }}</mat-label>
            <input matInput formControlName="zip">
        </mat-form-field>
        <span style="color: red;" *ngIf="(form.get('zip').errors?.zip && form.get('zip').value && form.get('zip').value !== '')">
            {{"common.validation.zip" | translate}}
        </span>

        <mat-form-field appearance="standard" color="standart" style="margin-bottom: -10px; width: 225px;">
            <mat-label>{{"registration.phone" | translate }}</mat-label>
            <input matInput formControlName="phone">
        </mat-form-field>
        <span style="color: red;" *ngIf="(form.get('phone').errors?.phone && form.get('phone').value && form.get('phone').value !== '')">
            {{"common.validation.phone" | translate}}
        </span>
    </form>
    <div class="d-flex" style="margin-top: 20px">
        <button mat-flat-button color="primary" class="action-button" (click)="register()" style="width: 225px">{{"registration.register" | translate}}</button>
    </div>
</div>